import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export const HowRevokeLyrics: React.FC = () => {
  return <div id={"HowRevokeLyrics"}>
    <h2>
      Как изъять текст песни
    </h2>
    <p>
      Для изъятия текста необходимо загрузить файл xlsx с заполнением всех полей, в поле Share укажите долю 0.
    </p>
  </div>;
};
